import { getFilterFunction, } from "./filter-function-registry.js";
function isRecord(value) {
    return !!value && typeof value === "object" && !Array.isArray(value);
}
function resolveDotPath(record, path) {
    const segments = path.split(".").filter(Boolean);
    if (segments.length === 0)
        return undefined;
    let current = record;
    for (const segment of segments) {
        if (!isRecord(current))
            return undefined;
        current = current[segment];
    }
    return current;
}
function resolveValueFromReference(reference, parentValues) {
    if (!reference)
        return undefined;
    if (!reference.startsWith("$parent."))
        return undefined;
    const path = reference.slice("$parent.".length);
    if (!path)
        return undefined;
    const [alias, ...rest] = path.split(".").filter(Boolean);
    if (!alias)
        return undefined;
    const parent = parentValues[alias];
    if (!parent)
        return undefined;
    if (rest.length === 0)
        return parent;
    return resolveDotPath(parent, rest.join("."));
}
function evaluateComparison(node, entity, parentValues) {
    const fieldValue = resolveDotPath(entity, node.field);
    const compareTo = node.valueFrom !== undefined
        ? resolveValueFromReference(node.valueFrom, parentValues)
        : node.value;
    if (node.op === "eq")
        return fieldValue === compareTo;
    return fieldValue !== compareTo;
}
function evaluateInNode(node, entity, parentValues) {
    const fieldValue = resolveDotPath(entity, node.field);
    const values = node.valuesFrom !== undefined
        ? resolveValueFromReference(node.valuesFrom, parentValues)
        : node.values;
    if (!Array.isArray(values))
        return false;
    return values.some((value) => value === fieldValue);
}
function evaluateNumericNode(node, entity) {
    const fieldValue = resolveDotPath(entity, node.field);
    if (typeof fieldValue !== "number")
        return false;
    switch (node.op) {
        case "gt":
            return fieldValue > node.value;
        case "gte":
            return fieldValue >= node.value;
        case "lt":
            return fieldValue < node.value;
        case "lte":
            return fieldValue <= node.value;
    }
}
export function evaluateFilterNode(filter, entity, parentValues = {}) {
    if (!filter)
        return true;
    switch (filter.op) {
        case "and":
            return filter.nodes.every((node) => evaluateFilterNode(node, entity, parentValues));
        case "or":
            return filter.nodes.some((node) => evaluateFilterNode(node, entity, parentValues));
        case "not":
            return !evaluateFilterNode(filter.node, entity, parentValues);
        case "eq":
        case "neq":
            return evaluateComparison(filter, entity, parentValues);
        case "in":
            return evaluateInNode(filter, entity, parentValues);
        case "exists": {
            const hasValue = resolveDotPath(entity, filter.field) !== undefined;
            return filter.value ? hasValue : !hasValue;
        }
        case "gt":
        case "gte":
        case "lt":
        case "lte":
            return evaluateNumericNode(filter, entity);
    }
}
export function evaluateCollectionMembership(input) {
    const parentValues = input.parentValues ?? {};
    const filterMatches = evaluateFilterNode(input.filter, input.entity, parentValues);
    if (!filterMatches)
        return false;
    if (!input.filterFnKey)
        return true;
    const filterFunction = getFilterFunction(input.filterFnKey);
    if (!filterFunction) {
        throw new Error(`Unknown framework filter function key: ${input.filterFnKey}`);
    }
    return filterFunction({
        entity: input.entity,
        pathScope: input.pathScope,
        parentValues,
    });
}
